module.exports = __webpack_public_path__ + "static/media/pexels-aleksandra-platonova-2263510-2.c4fca469.jpg";